import type { Person } from "@gui-creator/gemeinsam";
import { useQuery } from "@tanstack/react-query";
import { Check, CloudOff, LoaderCircle, LogIn } from "lucide-react";
import { api } from "../api/klient.ts";
import { useSpeicherstand } from "./live.ts";
import "./live.css";

const FARBEN = ["var(--person-1)", "var(--person-2)", "var(--person-3)", "var(--person-4)", "var(--person-5)", "var(--person-6)"];

export function personFarbe(kontoId: string, istClaude = false): string {
  if (istClaude) return "var(--person-claude)";
  let h = 0;
  for (const z of kontoId) h = (h * 31 + z.charCodeAt(0)) >>> 0;
  return FARBEN[h % FARBEN.length]!;
}

export function useAnwesende(ui: string | undefined) {
  return useQuery({
    queryKey: ["anwesenheit", ui ?? "-"],
    queryFn: () => api<Person[]>(`/api/anwesenheit/${ui}`),
    enabled: !!ui,
    refetchInterval: 20_000,
  });
}

export function Anwesenheit({ ui, ich }: { ui: string; ich: string }) {
  const personen = (useAnwesende(ui).data ?? []).filter((p) => p.kontoId !== ich);
  if (personen.length === 0) return null;
  const sichtbar = personen.slice(0, 4);
  return (
    <ul className="anwesenheit" aria-label={`${personen.length} weitere ${personen.length === 1 ? "Person" : "Personen"} in dieser UI`}>
      {sichtbar.map((p) => (
        <li key={p.kontoId} style={{ background: personFarbe(p.kontoId, p.istClaude) }} title={p.istClaude ? "Claude arbeitet gerade an dieser UI" : `${p.name} ist hier`}>
          {p.name.slice(0, 1).toUpperCase()}
        </li>
      ))}
      {personen.length > 4 && <li className="anwesenheit-mehr">+{personen.length - 4}</li>}
    </ul>
  );
}

export function Speicherstand() {
  const s = useSpeicherstand();
  const text = { gespeichert: "Gespeichert", speichert: "Speichert …", offline: "Offline – Änderungen werden nachgereicht", abgemeldet: "Abgemeldet – Änderungen warten" }[s];
  return (
    <span className={`speicherstand speicherstand-${s}`} role="status" aria-live="polite">
      {s === "gespeichert" && <Check size={13} aria-hidden="true" />}
      {s === "speichert" && <LoaderCircle size={13} className="dreht" aria-hidden="true" />}
      {s === "offline" && <CloudOff size={13} aria-hidden="true" />}
      {s === "abgemeldet" && <LogIn size={13} aria-hidden="true" />}
      <span className="speicherstand-text">{text}</span>
    </span>
  );
}
